/**
 * Far & Away one-at-a-time accordions (<details name="fa-accordion-…">, set by the accordion
 * row's "Open one row at a time" setting).
 *
 * The browser closes the other rows itself; browsers without exclusive <details> get the same
 * here. A row closing below the one being opened animates shut. A row closing above it would
 * pull the clicked row up by its height mid-animation, so that one closes at once, and the page
 * scrolls to keep the clicked row under the pointer before every paint until things settle.
 */

const PREFIX = 'fa-accordion-';
/** A little longer than the theme's open and close animation */
const HOLD_MS = 320;

/** Horizon scrolls .page-wrapper on desktop and the document on phones */
function scroller() {
  const wrapper = document.querySelector('.page-wrapper');
  if (
    wrapper instanceof HTMLElement &&
    wrapper.scrollHeight > wrapper.clientHeight + 1 &&
    /(auto|scroll)/.test(getComputedStyle(wrapper).overflowY)
  ) {
    return wrapper;
  }
  return document.scrollingElement || document.documentElement;
}

/** @param {EventTarget | null} target */
function groupedDetails(target) {
  const details = target instanceof Element ? target.closest('details') : null;
  return details instanceof HTMLDetailsElement && (details.getAttribute('name') || '').startsWith(PREFIX) ? details : null;
}

/** @param {HTMLDetailsElement} details */
function openSibling(details) {
  const name = CSS.escape(details.getAttribute('name') || '');
  const other = document.querySelector(`details[name="${name}"][open]`);
  return other instanceof HTMLDetailsElement && other !== details ? other : null;
}

if (!window.faAccordionGroup) {
  window.faAccordionGroup = true;

  // Clicks (and Enter or Space) on a closed row's summary, before the browser toggles anything
  document.addEventListener(
    'click',
    (event) => {
      const summary = event.target instanceof Element ? event.target.closest('summary') : null;
      const details = groupedDetails(summary);
      if (!summary || !details || details.open) return;
      const other = openSibling(details);
      const above = other && other.compareDocumentPosition(details) & Node.DOCUMENT_POSITION_FOLLOWING;
      if (above) other.setAttribute('data-fa-closing-above', '');

      // Hold the clicked row where it was, frame by frame, while the rows settle. On desktop the
      // details column is sticky and pinned by its bottom edge, so even a row opening below
      // would otherwise push this one up.
      const start = summary.getBoundingClientRect().top;
      const box = scroller();
      const until = performance.now() + HOLD_MS;
      const hold = () => {
        const drift = summary.getBoundingClientRect().top - start;
        // Instant, whatever the page's smooth-scroll setting: each step lands before its paint
        if (Math.abs(drift) >= 1) box.scrollBy({ top: drift, behavior: 'instant' });
        if (above) other.removeAttribute('data-fa-closing-above');
        if (performance.now() < until) requestAnimationFrame(hold);
      };
      requestAnimationFrame(hold);
    },
    { capture: true }
  );

  // Browsers without exclusive <details> close the other rows here ("toggle" does not bubble)
  if (!('name' in HTMLDetailsElement.prototype)) {
    document.addEventListener(
      'toggle',
      (event) => {
        const details = groupedDetails(event.target);
        if (!details?.open) return;
        let other = openSibling(details);
        while (other) {
          other.open = false;
          other = openSibling(details);
        }
      },
      { capture: true }
    );
  }
}
